import { useState } from "react";
import Layout from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { CheckCircle, Mail } from "lucide-react";
import http from "@/lib/api";
import { toast } from "sonner";

export default function KontaktSkjema() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Fyll ut navn, e-post og melding."); return; }
    setSubmitting(true);
    try {
      await http.post("/v1/contact-messages", form);
      setSubmitted(true);
      toast.success("Melding sendt!");
    } catch { toast.error("Noe gikk galt. Prøv igjen."); } finally { setSubmitting(false); }
  };

  if (submitted) {
    return (
      <Layout>
        <section className="py-24 bg-[#FFF8F0]">
          <div className="max-w-lg mx-auto px-4 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-6"><CheckCircle className="h-8 w-8 text-green-600" /></div>
            <h1 className="text-2xl font-bold text-[#3D2314] mb-4 font-display">Takk for din henvendelse!</h1>
            <p className="text-[#1A1A1A]/70 mb-6">Vi har mottatt meldingen din og svarer så snart vi kan – vanligvis innen én virkedag.</p>
            <Button onClick={() => { setSubmitted(false); setForm({ name: "", email: "", phone: "", message: "" }); }} className="bg-[#3D2314] hover:bg-[#3D2314]/90 text-white">Send ny melding</Button>
          </div>
        </section>
      </Layout>
    );
  }

  return (
    <Layout>
      <section className="bg-[#3D2314] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 font-display">Kontakt oss</h1>
          <p className="text-white/80 max-w-2xl mx-auto">Har du spørsmål? Send oss en melding, så tar vi kontakt.</p>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-[#FFF8F0]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-[#D4A574]/30 shadow-lg">
            <CardHeader><CardTitle className="text-xl text-[#3D2314] flex items-center gap-2"><Mail className="h-5 w-5" />Kontaktskjema</CardTitle></CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div><Label>Navn *</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 border-[#D4A574]/30" data-testid="ks-name" /></div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div><Label>E-post *</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 border-[#D4A574]/30" data-testid="ks-email" /></div>
                  <div><Label>Telefon</Label><Input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1 border-[#D4A574]/30" /></div>
                </div>
                <div><Label>Melding *</Label><Textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={5} className="mt-1 border-[#D4A574]/30" data-testid="ks-message" /></div>
                <Button type="submit" disabled={submitting} data-testid="ks-submit" className="w-full bg-[#D4A574] hover:bg-[#D4A574]/90 text-[#3D2314] font-semibold">{submitting ? "Sender..." : "Send melding"}</Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>
  );
}
